import React from 'react';
import { Box, Typography } from '@mui/material';

const StatisticCard = ({ icon: Icon, value, label }) => {
  return (
    <Box
      sx={{
        width: '100%',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 1,
        borderRadius: 1,
        transition: 'transform 220ms ease',
        transformOrigin: 'center',
        willChange: 'transform',
        '&:hover': {
          transform: 'scaleX(1.04) scaleY(1.03)',
          zIndex: 2,
        },
        '&:hover .stat-icon': {
          transform: 'scale(1.12)',
        },
        '&:hover .stat-value': {
          transform: 'scale(1.06)',
        },
      }}
    >
      <Box className="stat-icon" sx={{ lineHeight: 0, transition: 'transform 220ms ease' }}>
        <Icon sx={{ fontSize: 44 }} />
      </Box>
      <Typography
        className="stat-value"
        sx={{ fontWeight: 700, fontSize: '1.05rem', transition: 'transform 220ms ease' }}
      >
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
};

export default StatisticCard;

